<template>
    <!--保险免费安装审核-->
  <div>
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" placeholder="车牌号" style="width: 200px; margin-right: 3px;" clearable></Input>
      <Button type="primary" style="margin-right: 3px;" size="small" @click="onFilterClick">查询</Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content" ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @contextmenu.prevent.native="onTableRightClick($event)"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>

    <!-- 表格设置 -->
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name" v-model="webTableColumnsModal"></web-table-columns-modal>
    <free-installation-audit-picture-modal v-model="freeInstallationAuditPictureModal" :initValue="freeInstallationAuditPictureId" @on-success="onSuccess"></free-installation-audit-picture-modal>
    <free-installation-audit-add-processremark-modal v-model="freeInstallationAuditAddProcessremarkModal" :initValue="freeInstallationAuditAddProcessremarkId" @on-success="onSuccess"></free-installation-audit-add-processremark-modal>

  </div>
</template>

<script>
  import Vue from 'vue'
  import store from '@/store'
  import { mapActions } from 'vuex'
  import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
  import { numberFormat } from '@/libs/numberutil'

  import FreeInstallationAuditPictureModal from '@/view/crm/components/free-installation-audit-picture-modal'
  import FreeInstallationAuditAddProcessremarkModal from '@/view/crm/components/free-installation-audit-add-processremark-modal'

  export default {
        name: "usergroupfreeinstallationaudit",
    components:{
      FreeInstallationAuditPictureModal,
      FreeInstallationAuditAddProcessremarkModal,
    },
      data(){
          return{

            //重货保险免费安装主动安全设备登记审核
            freeInstallationAuditPictureModal:false,
            freeInstallationAuditPictureId:null,

            //重货保险免费安装主动安全设备登记审核追加备注
            freeInstallationAuditAddProcessremarkModal:false,
            freeInstallationAuditAddProcessremarkId:null,

            webTableColumnsModal: false,
            menuList: [
              { title: '设置表格列', content: {} }
            ],

            pageFilter: 30,
            pagesizeopts:[30, 50,100,200],
            keywordFilter: null,
            tableHeight: 160,
            pageIndex: 1,
            sort: null,
            listLoadding: false,
            //业务员筛选
            businessUserFilter: null,
            //审核情况筛选
            auditPassFilter: null,

            columns: [
              {
                title: 'ID',
                resizable: true,
                key: 'id',
                sortable: 'custom',
                tooltip: 'true',
                width: 130
              },
              {
                title: '车牌号',
                resizable: true,
                key: 'chePaiHao',
                ellipsis: 'true',
                width: 120
              },
              {
                title: '业户名称',
                resizable: true,
                key: 'yeHuMingCheng',
                ellipsis: 'true',
                width: 250
              },
              {
                title: '身份证号码/业户统一社会信用代码',
                resizable: true,
                key: 'shenFenZhengHaoMa',
                ellipsis: 'true',
                width: 160,
                render: function (h, params) {
                  if (params.row.shenFenZhengHaoMa != null) {
                    return h('div', params.row.shenFenZhengHaoMa)
                  }else {
                    return h('div', params.row.yeHuTongYiSheHuiXinYongDaiMa)
                  }
                }
              },
              {
                title: '业户负责人名称',
                resizable: true,
                key: 'yeHuFuZeRenXingMing',
                ellipsis: 'true',
                width: 130
              },
              {
                title: '业户负责人联系方式',
                resizable: true,
                key: 'yeHuFuZeRenLianXiFangShi',
                ellipsis: 'true',
                width: 150
              },
              {
                title: '司机名称',
                resizable: true,
                key: 'siJiXingMing',
                ellipsis: 'true',
                width: 100
              },
              {
                title: '司机联系方式',
                resizable: true,
                key: 'siJiLianXiFangShi',
                ellipsis: 'true',
                width: 150
              },
              {
                title: '审核情况',
                resizable: true,
                key: 'auditPass',
                ellipsis: 'true',
                width: 150,
                filters: [
                  { label: '待审核', value: null },
                  { label: '通过', value: 1 },
                  { label: '不通过', value: 0 },
                ],
                filterMultiple: true,
                filterRemote: (val) => {
                  if (val && val.length > 0) {
                    this.auditPassFilter = []
                    val.forEach(item => {
                      if (item == null){
                        this.auditPassFilter.push(genQueryParam('auditPass', 'EQNULL'))
                      } else {
                        this.auditPassFilter.push(genQueryParam('auditPass', 'EQ', item))
                      }
                    })
                  } else {
                    this.auditPassFilter = null
                  }
                  this.setPage(1)
                },
                render: function (h, params) {
                  if (params.row.auditPass != null) {
                    if (params.row.auditPass) {
                      return h('div', '通过')
                    } else {
                      return h('div', '不通过')
                    }
                  }else{
                    return h('div', '待审核')
                  }
                }
              },
              {
                title: '跟进业务员',
                resizable: true,
                key: 'businessUserId',
                ellipsis: 'true',
                tooltip: 'true',
                width: 120,
                filters: [],
                filterMultiple: true,
                filterRemote: (val) => {
                  if (val && val.length > 0) {
                    this.businessUserFilter = []
                    val.forEach(item => {
                      this.businessUserFilter.push(genQueryParam('businessUserId', 'EQ', item))
                    })
                  } else {
                    this.businessUserFilter = null
                  }
                  this.setPage(1)
                },
                render: function (h, params) {
                  if (params.row.businessUser) {
                    let name = null
                    if (params.row.businessUser.realName) {
                      name = params.row.businessUser.realName
                    } else if (params.row.businessUser.nickName) {
                      name = params.row.businessUser.nickName
                    } else if (params.row.businessUser.name) {
                      name = params.row.businessUser.name
                    }
                    return h('div', name)
                  }
                }
              },
              {
                title: '备注',
                resizable: true,
                ellipsis: 'true',
                tooltip: 'true',
                key: 'remark',
                width: 180
              },
              {
                title: '更新时间',
                resizable: true,
                sortable: 'custom',
                ellipsis: 'true',
                tooltip: 'true',
                key: 'updateDatetime',
                width: 220,
                render: function (h, params) {
                  if (params.row.updateDatetime) {
                    let d = new Date(params.row.updateDatetime)
                    return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
                  }
                }
              },
              {
                title: '创建时间',
                resizable: true,
                sortable: 'custom',
                ellipsis: 'true',
                tooltip: 'true',
                key: 'createDatetime',
                width: 220,
                render: function (h, params) {
                  if (params.row.createDatetime) {
                    let d = new Date(params.row.createDatetime)
                    return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
                  }
                }
              },
              {
                title: '操作',
                resizable: true,
                key: 'action',
                align: 'left',
                ellipsis: 'true',
                fixed: 'right',
                width: 240,
                render: (h, params) => {
                  return h('div', [
                    h('Button', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.freeInstallationAuditPictureId = params.row.id
                          this.freeInstallationAuditPictureModal = true
                        }
                      }
                    }, '详细信息'),
                    h('Button', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.freeInstallationAuditAddProcessremarkId = params.row.id
                          this.freeInstallationAuditAddProcessremarkModal = true
                        }
                      }
                    }, '追加备注'),
                    h('Button', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {


                        }
                      }
                    }, '上传锐明'),
                  ])
                }
              }
            ]// cloumn

          }
      },
      methods:{
        onSuccess () {
          this.refreshPage(this.pageFilter)
        },
        onModifySuccess () {
          this.refreshPage(this.pageFilter)
        },
        onFilterClick () {
          this.setPage(1)
        },
        setPage (page) {
          console.log('setPage' + page)
          this.pageIndex = page
          this.listLoadding = true

          let queryParams = []
          let sortParam = null

          if (this.sort) {
            sortParam = genSortParam(this.sort.name, this.sort.asc)
          }
          let qo1 = null
          if (this.businessUserFilter) {
            qo1 = this.businessUserFilter
          }
          let qo2 = null
          if (this.auditPassFilter) {
            qo2 = this.auditPassFilter
          }

          store.dispatch('RmFreeServ_GetMyMaintainGroupPage', {
            params: null,
            urlparams: {
              q: queryParams,
              qo1: qo1,
              qo2: qo2,
              ps: this.pageFilter,
              p: page,
              keyword: this.keywordFilter,
              sort: sortParam
            }
          }).then(() => {
            this.listLoadding = false
          }).catch(err => {
            this.listLoadding = false
            this.$Message.error(err)
          })
        },
        // 刷新当前页
        refreshPage (value) {
          this.pageFilter = value
          this.setPage(this.pageIndex)
        },
        /**
         * 右键菜单点击回调
         */
        onContextMenuCallback (item) {
          if (item.title === '设置表格列') {
            this.webTableColumnsModal = true
          }
        },
        /**
         * 表格右键回调
         */
        onTableRightClick (e) {
          this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
        },
        sortChange ({ column, key, order }) {
          this.sort = {
            name: key,
            asc: order === 'asc'
          }
          this.refreshPage(this.pageFilter)
        },
        onColumnUpdate () {
          for (let i = 0; i < this.columns.length; i++) {
            if (this.columns[i].title === '跟进业务员') {
              this.columns[i].filters = this.marketsales
              break
            }
          }
        },
      },
      computed: {
        totalElements () {
          if (store.getters.get_RmFree_GetMyMaintainGroupPageResult) {
            return store.getters.get_RmFree_GetMyMaintainGroupPageResult.totalElements
          } else {
            return 0
          }
        },
        content () {
          if (store.getters.get_RmFree_GetMyMaintainGroupPageResult) {
            return store.getters.get_RmFree_GetMyMaintainGroupPageResult.content
          } else {
            return []
          }
        },
        pageSize () {
          if (store.getters.get_RmFree_GetMyMaintainGroupPageResult) {
            return store.getters.get_RmFree_GetMyMaintainGroupPageResult.size
          } else {
            return 0
          }
        }
      },
      mounted () {
        this.$nextTick(() => {
          this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
          window.onresize = () => {
            this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
          }

          store.dispatch('UserServ_GetAllUsers', {
            params: {},
            urlparams: { roleIds: [7] }
          }).then(() => {
            let marketsales = store.getters.get_User_GetAllUsersResult
            this.marketsales = marketsales.map(item => {
              return { label: item.realName, value: item.id }
            })
            // this.columns[4].filters = this.installers
            // this.columns[13].filters = this.marketsales
            this.onColumnUpdate()
          }).catch(err => {
            this.$Message.error(err)
          })

          this.setPage(1)
        })
      }
    }
</script>

<style scoped>

</style>
